import { render, staticRenderFns } from "./MacroData.vue?vue&type=template&id=8813b226&scoped=true&"
import script from "./MacroData.vue?vue&type=script&lang=js&"
export * from "./MacroData.vue?vue&type=script&lang=js&"
import style0 from "./MacroData.vue?vue&type=style&index=0&id=8813b226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8813b226",
  null
  
)

export default component.exports